import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('Token') || 'mock-token';
  config.headers.Authorization = `Bearer ${token}`;
  if (token === 'mock-token') {
    const user = JSON.parse(sessionStorage.getItem('user') || '{}');
    config.headers['x-mock-role'] = user.role || 'ADMIN';
    config.headers['x-mock-user'] = user.loginName || 'admin';
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      sessionStorage.clear();
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export default api;
